$(document).ready(function() {
    $('.toggle-filters').on('click', function () {
        $('.toggle-filters-elements').toggle();
    });
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/modules/filter.js
// module id = 18
// module chunks = 0